import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchUserDashboard } from '../../../../api/userDashboardApi';
import '../TrainingMockExamSection.css';

const Exam = () => {
  const [examData, setExamData] = useState([]);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const fetchDashboard = async () => {
      try {
        const dashboard = await fetchUserDashboard(userId);
        setExamData(dashboard?.exam || []);
      } catch (error) {
        // console.error('Error fetching dashboard data:', error);
        setExamData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  return (
    <div className="exam-exam-container">
      <h2 className='heading-for-dashboard-user' style={{ textAlign: 'start' }}>🪧 Exam</h2>
      {loading ? (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      ) : examData.length === 0 ? (
        <div className="spinner-container">
          <div className="no-data-user-dashboard">No Exam Assigned!</div>
        </div>
      ) : (
        <div className="training-container">
          {examData.map((exam) => (
            <div className="insurance-card" key={exam.examId}>
              <div className="card-header">
                <h2>{exam.examName}</h2>
                <div className="category">
                  <Link to={`/user/start-exam-quiz/${exam.examId}`}>
                    <button className="go-to-training-btn">Go to Exam</button>
                  </Link>
                </div>
              </div>
              <div className="policy-details">
                <div className="detail-row">
                  <span className="label">Number of Questions:</span>
                  <span className="value">{exam.numberOfQuestions}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Duration (mins):</span>
                  <span className="value">{exam.durationMinutes}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Exam;
